<script>
import { mapGetters } from 'vuex';
import AverageEggProduction from '@/layerAdmin/components/AverageEggProduction.vue';

export default {
  computed: {
    ...mapGetters('auth', ['userHasRole']),

    visibleWidgets() {
      let widgets = [];

      if (this.userHasRole('LayerAdmin')) {
        widgets.push({ title: 'Average Egg Production', component: AverageEggProduction });
      }

      return widgets;
    },
  },
}
</script>

<template>
  <div>
    <div v-for="widget in visibleWidgets" :key="widget.title">
      <component :is="widget.component">
      </component>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/home/components/Dashboard.vue